import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { FlowBuilder } from "@/components/automations/builder"
import { automationQuery } from "@/lib/queries"

export const Route = createFileRoute("/w/$workspace/automations/$automationId/")({ component: BuilderRoute })

function BuilderRoute() {
  const { workspace, automationId } = Route.useParams()
  const automation = useSuspenseQuery(automationQuery(workspace, automationId)).data
  return <FlowBuilder key={`${automation.id}:${automation.draft?.versionId ?? automation.live?.versionId ?? "none"}`} automation={automation} />
}
